module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "fixed pin z-50 overflow-auto bg-smoke-light flex"
  }, [(_vm.show) ? _c('on-click-outside', {
    attrs: {
      "do": function () { return _vm.close; }
    }
  }, [_c('div', {
    staticClass: "relative rounded-lg shadow-lg bg-white w-full m-auto flex-col flex",
    class: _vm.maxWidthClass
  }, [_c('span', {
    staticClass: "absolute pin-t pin-r p-4",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "h-4 w-4 text-grey-lighter hover:text-grey-darkest",
    attrs: {
      "role": "button",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('title', [_vm._v("Close")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bg-grey-lightest p-3 rounded-t text-grey-darkest"
  }, [_vm._t("header", [_c('h3', {
    staticClass: "p-3 modal-title"
  }, [_vm._v("Modal title")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_vm._t("body", [_c('p', [_vm._v("Modal body text goes here.")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "bg-grey-lighter rounded-b-lg p-3 flex justify-end"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "text-white p-2 bg-blue font-semibold rounded-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n            Save changes\n          ")])])], 2)])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063a3cd6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Modal.vue
// module id = 553
// module chunks = 66